import carriers from '@/api/modules/carriers';


export default {
	async getCarrierList({ commit }) {
		try {
			commit('setCarrierList', []);
			const result = await carriers.getList();
			commit('setCarrierList', result);
		} catch (err) {
			//
		}
	},

	async createCarrier({ commit }, body) {
		try {
			const result = await carriers.createCarrier(body);
			commit('createCarrier', result);
		} catch(err) {
			//
		}
	},

	async editCarrier({ commit }, body) {
		try {
			const result = await carriers.editCarrier(body);
			commit('editCarrier', result);
		} catch(err) {
			//
		}
	},

	async deleteCarrier({ commit }, id) {
		try {
			await carriers.deleteCarrier(id);
			commit('deleteCarrier', id);
		} catch(err) {
			//
		}
	}
};
